import { api } from './index';

const BASE_PATH = '/api/internal/task_definitions';

export type TaskDefinition = {
  id: number;
  name: string;
  description: string;
  taskCategoryId: number;
  taskCategoryName: string;
  taskCategoryDiscardedAt?: string;
  discardedAt?: string;
  discarded: boolean;
  humanCreatedAt: string;
  humanDiscardedAt?: string;
};

export interface TaskDefinitionForm {
  id?: number;
  name: string;
  description: string;
  taskCategoryId: number;
}

interface IndexParams {
  taskCategoryId?: number;
  scope?: 'active' | 'discarded';
}

export const taskDefinitionsApi = {
  index(taskCategoryId?: number, scope?: 'active' | 'discarded'): Promise<Array<TaskDefinition>> {
    const params: IndexParams = {};
    if (taskCategoryId) params.taskCategoryId = taskCategoryId;
    if (scope === 'discarded') params.scope = 'discarded';

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then(response => response.data.taskDefinitions);
  },
  create(taskDefinitionForm: TaskDefinitionForm): Promise<TaskDefinition> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { taskDefinition: taskDefinitionForm },
    }).then(response => response.data.taskDefinition);
  },
  update(taskDefinitionForm: Partial<TaskDefinitionForm>): Promise<TaskDefinition> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${taskDefinitionForm.id}`,
      data: { taskDefinition: taskDefinitionForm },
    }).then(response => response.data.taskDefinition);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    });
  },
};
